import { memo } from 'react';
import { motion } from 'motion/react';

import { useGetParams } from '../../../hooks/useGetParams';

import styles from './AdvtFullSize.module.css';

import logo from '../../../assets/images/logo.png';

export const AdvtFullSize = memo(() => {
  const { title, qrCode1, sizeQR, titleFontSize } = useGetParams();

  const initDelay = 0.5;

  return (
    <div className={styles.wrapper}>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
        className={styles.logoBlock}
      >
        <img src={logo} alt="" className={styles.logo} />
      </motion.div>
      {title && (
        <div
          className={styles.titleBlock}
          style={{ fontSize: `${titleFontSize}rem` }}
        >
          <motion.div
            className={styles.titleBg}
            initial={{ scaleX: 0, originX: '100%' }}
            animate={{ scaleX: 1, originX: '100%' }}
            transition={{
              scaleX: { duration: 0.5, delay: 1.5 + initDelay },
            }}
          />

          <motion.div
            className={styles.title}
            initial={{
              y: '100%',
              maskPosition: '0% 100%',
              WebkitMaskPosition: '0% 100%',
            }}
            animate={{
              y: 0,
              maskPosition: '0% 0%',
              WebkitMaskPosition: '0% 0%',
            }}
            transition={{ delay: 1.9, duration: 0.5 + initDelay }}
          >
            {title}
          </motion.div>
        </div>
      )}

      {qrCode1 && (
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: [0, 1.1, 1] }}
          transition={{
            scale: {
              times: [0, 0.8, 1],
              duration: 1,
              ease: 'easeOut',
              delay: 0.5 + initDelay,
            },
          }}
          className={styles.qrCode}
          style={{
            width: `${sizeQR}rem`,
            height: `${sizeQR}rem`,
          }}
        >
          <img src={qrCode1} alt="" />
        </motion.div>
      )}
    </div>
  );
});
